import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import { requireBase } from "../../core/require.js"
import React from "react";

interface ReactTemplateProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: ReactTemplateState;
    settings: any;
}

export class ReactTemplateComponent extends React.Component<ReactTemplateProps, { reactComponent?: any, data?: any[] }> {
    public static get NAME(): string { return "ReactTemplate"; }
    private reactStateWrapper: ReactTemplateState;

    constructor(props, context) {
        super(props, context);
        this.reactStateWrapper = new ReactTemplateState();
        this.reactStateWrapper.hydrateFromJS(props.settings);

        this.state = { reactComponent: this.reactStateWrapper.template ? this.initReactComponent(this.reactStateWrapper.template.transpiledCode) : null };
    }

    handleDataChanged = (allData) => {
        if (this.reactStateWrapper.dataSource) {
            let result = allData[this.reactStateWrapper.dataSource.getDataSourceIdentifier() + this.props.uid];
            if (!result) {
                result = allData[this.reactStateWrapper.dataSource.getDataSourceIdentifier()];
            }

            if (result && result.Data) {
                this.setState({ data: result.Data });
            }
        }
    }

    initReactComponent = (sourceCode: string): any => {
        const require = (modules,callback)=>{requireBase("/app/statistics/statistic_components",modules,callback)};
        try {
            const result = this.evalWithCustomRequire(sourceCode, require);
            if (result) {
                return result;
            }
        } catch (e) {

        }
            return null;
        }

        evalWithCustomRequire = (sourceCode: string, require) => {
            return eval(sourceCode);
        }

        registerComponent = (uid: string, services: string[], datasources: datasources.Datasource[]) => {
            this.props.context.registerComponent(uid, services, this.handleDataChanged, null, datasources);
        }

        UNSAFE_componentWillMount() {
            this.registerComponent(this.props.uid, null, [this.reactStateWrapper.dataSource]);
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            const oldDataSourceId = !this.reactStateWrapper.dataSource ? null : this.reactStateWrapper.dataSource.getDataSourceIdentifier();

            const newProps = new ReactTemplateState();
            newProps.hydrateFromJS(nextProps.settings);

            if (newProps.template && this.reactStateWrapper.template && this.reactStateWrapper.template.transpiledCode != newProps.template.transpiledCode) {
                this.setState({ reactComponent: this.initReactComponent(newProps.template.transpiledCode) });
            }

            this.reactStateWrapper = newProps;

            if (this.reactStateWrapper.dataSource && this.reactStateWrapper.dataSource.getDataSourceIdentifier() != oldDataSourceId) {

                this.registerComponent(nextProps.uid, null, [this.reactStateWrapper.dataSource]);
                this.props.context.loadMissingData(this.props.queryParameter);
            }


        }

        componentWillUnmount() {
            this.props.context.unregisterComponent(this.props.uid);
        }

        reloadStatistic = () => {
            this.props.context.reloadCurrentData();
        }

        render() {
            return <react_components.ReactColumn width={this.props.metadataSettings.width} height={this.props.context.fullHeightLayout ? "100%" : null}>
                <ErrorBoundary>
                    {this.state.reactComponent ? React.createElement(this.state.reactComponent, { data: this.state.data || [], context: this.props.context.variables, api: { reloadStatistic: this.reloadStatistic } }) : null}
                </ErrorBoundary>
            </react_components.ReactColumn>
        }
    };


export class ReactTemplateState extends propertyTypes.BaseComponentProps {
    private templateMetadata = new propertyTypes.ReactTemplateProperty("template", "Template");
    public template: { sourceCode: string, transpiledCode: string };

    public dataSource: datasources.Datasource;

    private templateMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.templateMetadataAll = baseMetaData.concat([this.templateMetadata, datasources.dataSourceMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.templateMetadataAll;
    }
}